/*! @pentacode/ui v0.1.0 */
import { a as e, b as t, c as n, f as r, g as i, h as a, l as o, m as s, p as c, v as l, w as u, x as d } from "./guide-layout-CrWsmVuf.js";
import { b as f, y as p } from "./shared-D0HMDGlg.js";
import { t as m } from "./mark-with-scale-values-BK-kseMB.js";
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/math.js
var h = Math.abs, g = Math.atan2, _ = Math.cos, v = Math.max, y = Math.min, b = Math.sin, x = Math.sqrt, S = Math.PI, C = S / 2, w = 2 * S;
function T(e) {
	return e > 1 ? 0 : e < -1 ? S : Math.acos(e);
}
function E(e) {
	return e >= 1 ? C : e <= -1 ? -C : Math.asin(e);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/arc.js
function D(e) {
	return e.innerRadius;
}
function O(e) {
	return e.outerRadius;
}
function k(e) {
	return e.startAngle;
}
function A(e) {
	return e.endAngle;
}
function j(e) {
	return e && e.padAngle;
}
function M(e, t, n, r, i, a, o, s) {
	var c = n - e, l = r - t, u = o - i, d = s - a, f = d * c - u * l;
	if (!(f * f < 1e-12)) return f = (u * (t - a) - d * (e - i)) / f, [e + f * c, t + f * l];
}
function N(e, t, n, r, i, a, o) {
	var s = e - n, c = t - r, l = (o ? a : -a) / x(s * s + c * c), u = l * c, d = -l * s, f = e + u, p = t + d, m = n + u, h = r + d, g = (f + m) / 2, _ = (p + h) / 2, y = m - f, b = h - p, S = y * y + b * b, C = i - a, w = f * h - m * p, T = (b < 0 ? -1 : 1) * x(v(0, C * C * S - w * w)), E = (w * b - y * T) / S, D = (-w * y - b * T) / S, O = (w * b + y * T) / S, k = (-w * y + b * T) / S, A = E - g, j = D - _, M = O - g, N = k - _;
	return A * A + j * j > M * M + N * N && (E = O, D = k), {
		cx: E,
		cy: D,
		x01: -u,
		y01: -d,
		x11: E * (i / C - 1),
		y11: D * (i / C - 1)
	};
}
function P() {
	var e = D, t = O, n = f(0), r = null, i = k, a = A, o = j, s = null, c = p(l);
	function l() {
		var l, u, d = +e.apply(this, arguments), f = +t.apply(this, arguments), p = i.apply(this, arguments) - C, m = a.apply(this, arguments) - C, v = h(m - p), D = m > p;
		if (s ||= l = c(), f < d && (u = f, f = d, d = u), !(f > 1e-12)) s.moveTo(0, 0);
		else if (v > w - 1e-12) s.moveTo(f * _(p), f * b(p)), s.arc(0, 0, f, p, m, !D), d > 1e-12 && (s.moveTo(d * _(m), d * b(m)), s.arc(0, 0, d, m, p, D));
		else {
			var O = p, k = m, A = p, j = m, P = v, F = v, I = o.apply(this, arguments) / 2, L = I > 1e-12 && (r ? +r.apply(this, arguments) : x(d * d + f * f)), R = y(h(f - d) / 2, +n.apply(this, arguments)), z = R, B = R, V, H;
			if (L > 1e-12) {
				var U = E(L / d * b(I)), W = E(L / f * b(I));
				(P -= U * 2) > 1e-12 ? (U *= D ? 1 : -1, A += U, j -= U) : (P = 0, A = j = (p + m) / 2), (F -= W * 2) > 1e-12 ? (W *= D ? 1 : -1, O += W, k -= W) : (F = 0, O = k = (p + m) / 2);
			}
			var G = f * _(O), K = f * b(O), q = d * _(j), J = d * b(j);
			if (R > 1e-12) {
				var Y = f * _(k), X = f * b(k), Z = d * _(A), ee = d * b(A), Q;
				if (v < S) {
					if (Q = M(G, K, Z, ee, Y, X, q, J)) {
						var te = G - Q[0], ne = K - Q[1], re = Y - Q[0], ie = X - Q[1], ae = 1 / b(T((te * re + ne * ie) / (x(te * te + ne * ne) * x(re * re + ie * ie))) / 2), oe = x(Q[0] * Q[0] + Q[1] * Q[1]);
						z = y(R, (d - oe) / (ae - 1)), B = y(R, (f - oe) / (ae + 1));
					} else z = B = 0;
				}
			}
			F > 1e-12 ? B > 1e-12 ? (V = N(Z, ee, G, K, f, B, D), H = N(Y, X, q, J, f, B, D), s.moveTo(V.cx + V.x01, V.cy + V.y01), B < R ? s.arc(V.cx, V.cy, B, g(V.y01, V.x01), g(H.y01, H.x01), !D) : (s.arc(V.cx, V.cy, B, g(V.y01, V.x01), g(V.y11, V.x11), !D), s.arc(0, 0, f, g(V.cy + V.y11, V.cx + V.x11), g(H.cy + H.y11, H.cx + H.x11), !D), s.arc(H.cx, H.cy, B, g(H.y11, H.x11), g(H.y01, H.x01), !D))) : (s.moveTo(G, K), s.arc(0, 0, f, O, k, !D)) : s.moveTo(G, K), !(d > 1e-12) || !(P > 1e-12) ? s.lineTo(q, J) : z > 1e-12 ? (V = N(q, J, Y, X, d, -z, D), H = N(G, K, Z, ee, d, -z, D), s.lineTo(V.cx + V.x01, V.cy + V.y01), z < R ? s.arc(V.cx, V.cy, z, g(V.y01, V.x01), g(H.y01, H.x01), !D) : (s.arc(V.cx, V.cy, z, g(V.y01, V.x01), g(V.y11, V.x11), !D), s.arc(0, 0, d, g(V.cy + V.y11, V.cx + V.x11), g(H.cy + H.y11, H.cx + H.x11), D), s.arc(H.cx, H.cy, z, g(H.y11, H.x11), g(H.y01, H.x01), !D))) : s.arc(0, 0, d, j, A, D);
		}
		if (s.closePath(), l) return s = null, l + "" || null;
	}
	return l.centroid = function() {
		var n = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, r = (+i.apply(this, arguments) + +a.apply(this, arguments)) / 2 - S / 2;
		return [_(r) * n, b(r) * n];
	}, l.innerRadius = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : f(+t), l) : e;
	}, l.outerRadius = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : f(+e), l) : t;
	}, l.cornerRadius = function(e) {
		return arguments.length ? (n = typeof e == "function" ? e : f(+e), l) : n;
	}, l.padRadius = function(e) {
		return arguments.length ? (r = e == null ? null : typeof e == "function" ? e : f(+e), l) : r;
	}, l.startAngle = function(e) {
		return arguments.length ? (i = typeof e == "function" ? e : f(+e), l) : i;
	}, l.endAngle = function(e) {
		return arguments.length ? (a = typeof e == "function" ? e : f(+e), l) : a;
	}, l.padAngle = function(e) {
		return arguments.length ? (o = typeof e == "function" ? e : f(+e), l) : o;
	}, l.context = function(e) {
		return arguments.length ? (s = e ?? null, l) : s;
	}, l;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/pointRadial.js
function F(e, t) {
	return [(t = +t) * Math.cos(e -= Math.PI / 2), t * Math.sin(e)];
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/composite-motion-internal.js
function I(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function L(e, t, n) {
	let r;
	for (let e of t.keys()) (n.markId === e || n.markId?.startsWith(`${e}:`)) && (!r || e.length > r.length) && (r = e);
	return R(I(e, n), r ? I(t.get(r), n) : void 0);
}
function R(e, t) {
	if (t === !1) return !1;
	if (t === void 0) return e;
	if (e === !1 || e === void 0) return t;
	let n = t.path ?? e.path;
	return {
		delay: t.delay ?? e.delay,
		...n === void 0 ? {} : { path: n },
		transition: z(e.transition, t.transition)
	};
}
function z(e, t) {
	return e ? t ? e.type === t.type ? {
		...e,
		...t
	} : t : e : t;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/transform-internal.js
function B(e) {
	return Array.isArray(e) ? e : Array.from(e);
}
function V(e, t) {
	if (typeof t == "function") {
		let n = t;
		return e.map((t, r) => n(t, {
			index: r,
			data: e
		}));
	}
	return e.map((e) => typeof e == "object" && e ? e[t] : void 0);
}
function H(e, t, n, r = "ascending") {
	if (n === void 0) return [...t];
	let i = V(e, n), a = r === "descending" ? -1 : 1;
	return [...t].sort((e, t) => {
		let n = i[e], r = i[t], o = U(n, r);
		return o === 0 ? e - t : o * a;
	});
}
function U(e, t) {
	let n = e instanceof Date ? e.getTime() : e, r = t instanceof Date ? t.getTime() : t;
	return n < r ? -1 : +(n > r);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/proportional-interval-internal.js
function W(e, t = {}) {
	let n = t.start ?? 0, r = t.end ?? 1, i = t.gap ?? 0;
	G(n, "start"), G(r, "end"), K(i, "gap");
	let a = r - n;
	if (!Number.isFinite(a)) throw TypeError("proportional intervals: extent span must be finite");
	let o = 0, s = 0, c = 0;
	e.forEach((e, t) => {
		if (!Number.isFinite(e) || e < 0) throw TypeError(`proportional intervals: weight at index ${t} must be nonnegative and finite`);
		e > 0 && (o += 1), s += e, c = Math.max(c, e);
	});
	let l = Number.isFinite(s) ? 1 : c, u = l === 1 ? s : e.reduce((e, t) => e + t / l, 0), d = Math.abs(a), f = (o === 0 ? 0 : Math.max(0, o - 1) + +(t.gapAfterLast === !0)) * i;
	if (!Number.isFinite(f) || f > d) throw TypeError("proportional intervals: gap leaves insufficient extent");
	let p = d - f;
	if (o > 0 && p <= 0) throw TypeError("proportional intervals: positive weights require drawable extent");
	let m = a < 0 ? -1 : 1, h = [], g = n, _ = o;
	for (let n of e) {
		let e = u === 0 ? 0 : n / l / u, a = g, o = g;
		n > 0 && (--_, o = _ === 0 ? r - (t.gapAfterLast === !0 ? m * i : 0) : g + m * p * e, g = o, (_ > 0 || t.gapAfterLast === !0) && (g += m * i)), h.push({
			fraction: e,
			start: a,
			end: o
		});
	}
	return h;
}
function G(e, t) {
	if (!Number.isFinite(e)) throw TypeError(`proportional intervals: ${t} must be finite`);
}
function K(e, t) {
	if (!Number.isFinite(e) || e < 0) throw TypeError(`proportional intervals: ${t} must be nonnegative and finite`);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/polar-mark-internal.js
function q(e, t, r) {
	return {
		...t === void 0 ? {} : { motion: t },
		...r === void 0 ? {} : { renderer: r },
		initialize(i) {
			let a = e(i), o = t === void 0 || a.motion !== void 0 ? a : {
				...a,
				motion: t
			};
			if (r === void 0) return o;
			let s = o.render;
			return {
				...o,
				render: (e) => n(s(e), r)
			};
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/polar-focus-internal.js
var J = /* @__PURE__ */ Symbol("tanstack-charts-polar-focus");
function Y(e, t, n, r, i, a) {
	return Object.assign(e, { [J]: [
		t,
		n,
		r,
		i,
		a
	] });
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/polar-sector-internal.js
var X = Math.PI * 2;
function Z(e, t, n, r) {
	let i = [], a = (e, t) => {
		if (!s(e) || !s(t)) return;
		let n = i.at(-1);
		n && Math.abs(n[0] - e) <= 1e-9 && Math.abs(n[1] - t) <= 1e-9 || i.push([e, t]);
	}, o = {
		moveTo: a,
		lineTo: a,
		arc(e, t, n, r, i, o = !1) {
			let c = ee(r, i, o);
			if (!s(c)) return;
			if (c === 0) {
				a(e + n * Math.cos(r), t + n * Math.sin(r));
				return;
			}
			let l = Math.max(1, Math.ceil(Math.abs(c) / (Math.PI / 24)));
			for (let i = 0; i <= l; i += 1) {
				let o = r + c * i / l;
				a(e + n * Math.cos(o), t + n * Math.sin(o));
			}
		},
		closePath() {}
	}, c = e.context();
	e.context(o);
	try {
		e(t, n, r);
	} finally {
		e.context(c);
	}
	return i;
}
function ee(e, t, n) {
	let r = t - e;
	if (!s(r)) return NaN;
	if (n) {
		if (r <= -X) return -X;
		let e = r % X;
		return e > 0 ? e - X : e;
	}
	if (r >= X) return X;
	let i = r % X;
	return i < 0 ? i + X : i;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/polar-pie.js
var Q = Math.PI * 2, te = 1e-12;
function ne(e, t) {
	let n = B(e), r = V(n, t.value), i = t.startAngle ?? 0, a = t.endAngle ?? Q, o = t.gapAngle ?? 0;
	ae(i, "startAngle"), ae(a, "endAngle"), oe(o, "gapAngle");
	let s = a - i;
	if (!Number.isFinite(s) || Math.abs(s) > Q) throw TypeError("pie: angular sweep must be no greater than 2π");
	let c = r.flatMap((e, t) => {
		if (!ie(e)) return [];
		if (e < 0) throw TypeError(`pie: value at index ${t} must be nonnegative`);
		return [t];
	}), l = H(n, c, t.orderBy, t.order), u = Math.abs(Math.abs(s) - Q) <= te;
	re(l, r, s, o, u);
	let d = W(l.map((e) => r[e]), {
		start: i,
		end: a,
		gap: o,
		gapAfterLast: u
	}), f = /* @__PURE__ */ new Map();
	return l.forEach((e, t) => {
		let n = d[t], i = r[e];
		f.set(e, {
			value: i,
			index: t,
			fraction: n.fraction,
			startAngle: n.start,
			endAngle: n.end,
			angle: n.start + (n.end - n.start) / 2,
			padAngle: 0
		});
	}), c.map((e) => {
		let t = n[e];
		return {
			...t,
			...f.get(e),
			source: [t],
			sourceIndexes: [e]
		};
	});
}
function re(e, t, n, r, i) {
	let a = e.reduce((e, n) => e + +(t[n] > 0), 0), o = Math.abs(n), s = (a === 0 ? 0 : i ? a : Math.max(0, a - 1)) * r;
	if (!Number.isFinite(s) || s > o) throw TypeError("pie: gapAngle leaves insufficient angular space");
	let c = o - s;
	if (a > 0 && c <= 0) throw TypeError("pie: positive values require drawable angular space");
}
function ie(e) {
	return typeof e == "number" && Number.isFinite(e);
}
function ae(e, t) {
	if (!Number.isFinite(e)) throw TypeError(`pie: ${t} must be finite`);
}
function oe(e, t) {
	if (!Number.isFinite(e) || e < 0) throw TypeError(`pie: ${t} must be nonnegative and finite`);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/polar.js
var se = Math.PI * 2;
function ce(e) {
	return m(({ markIndex: t }) => {
		let n = e.id ?? `polar-${t}`, r = e.marks.map((t, r) => {
			let i = t.initialize({
				markIndex: r,
				parentId: n,
				states: e.states
			});
			return {
				...i,
				angleScale: i.angleScale ?? (i.requiresAngleScale ? "angle" : void 0),
				radiusScale: i.radiusScale ?? (i.requiresRadiusScale ? "radius" : void 0)
			};
		}), i = new Map(r.flatMap((t, n) => {
			let r = t.motion ?? e.marks[n]?.motion;
			return r === void 0 ? [] : [[t.id, r]];
		})), a = e.motion !== void 0 || i.size > 0 ? (t) => L(e.motion, i, t) : void 0;
		return {
			id: n,
			...a === void 0 ? {} : { motion: a },
			channels: { color: {
				scale: "color",
				values: r.flatMap((e) => e.colorValues)
			} },
			render: ({ chart: t, color: i, theme: a, layout: o }) => {
				let s = de(e, t, r, o.typography?.direction);
				for (let e of r) e.angleScale && ge(s, e.angleScale, "angle", `Polar mark "${e.id}"`), e.radiusScale && ge(s, e.radiusScale, "radius", `Polar mark "${e.id}"`);
				let c = [], l = [], u = [];
				for (let [t, r] of (e.guides ?? []).entries()) {
					let e = r.render({
						layout: s,
						theme: a,
						guideIndex: t,
						parentId: n
					});
					for (let t of e.background) c.push(t);
					for (let t of e.foreground ?? []) l.push(t);
				}
				for (let e of r) {
					let t = e.render({
						layout: s,
						color: i,
						theme: a
					});
					if (e.states) c.push({
						kind: "group",
						key: `states:${e.id}`,
						children: t.nodes,
						states: {
							...e.states,
							points: t.points ?? []
						}
					});
					else for (let e of t.nodes) c.push(e);
					for (let e of t.points ?? []) u.push(e);
				}
				for (let e of l) c.push(e);
				return {
					nodes: [{
						kind: "group",
						key: n,
						className: we("ts-chart__polar", e.className),
						translateX: s.centerX,
						translateY: s.centerY,
						ariaHidden: !0,
						children: c
					}],
					points: u
				};
			}
		};
	}, e.motion, e.renderer);
}
function le(e, n = {}) {
	let a = be(e);
	return he(({ markIndex: e, parentId: c, states: u }) => {
		let f = n.id ?? `${c}:arc-${e}`, p = o(a, n.startAngle, (e) => ye(e, "startAngle")), m = o(a, n.endAngle, (e) => ye(e, "endAngle")), h = o(a, n.padAngle, (e) => ye(e, "padAngle") ?? 0), g = o(a, n.z, () => null), _ = n.color === void 0 ? g : o(a, n.color, () => null), v = r(a, n.key, { groups: g });
		return {
			id: f,
			states: i(a, n.states ?? u),
			colorValues: _.filter(t),
			angleValues: [],
			radiusValues: [],
			includeZeroRadius: !1,
			requiresAngleScale: !1,
			requiresRadiusScale: !1,
			render: ({ layout: e, color: t }) => {
				let r = $(n.innerRadius, e, 0), i = $(n.outerRadius, e, e.radius), o = n.generator?.(e) ?? P().startAngle((e, t) => p[t] ?? 0).endAngle((e, t) => m[t] ?? 0).padAngle((e, t) => h[t] ?? 0).innerRadius(r).outerRadius(i).cornerRadius($(n.cornerRadius, e, 0));
				n.padRadius !== void 0 && !n.generator && o.padRadius($(n.padRadius, e, 0));
				let c = [], u = [];
				return a.forEach((r, i) => {
					let y = p[i], b = m[i], x = h[i];
					if (!n.generator && (!s(y) || !s(b) || !s(x))) return;
					let S = o(r, i, a);
					if (typeof S != "string" || !S) return;
					let C = g[i] ?? null, w = t(_[i] ?? null), T = l(n.fill, r, i, a, w), E = n.stroke === void 0 ? void 0 : l(n.stroke, r, i, a, w), D = `${f}:${d(C)}:${d(v[i])}`, O = o.startAngle()(r, i, a), k = o.endAngle()(r, i, a), A = o.innerRadius()(r, i, a), j = o.outerRadius()(r, i, a), M = o.centroid(r, i, a), N = (O + k) / 2, P = (A + j) / 2, F = Y({
						key: D,
						markId: f,
						group: C,
						groupLabel: C == null ? f : String(C),
						datum: r,
						datumIndex: i,
						xValue: N,
						yValue: P,
						x: e.centerX + M[0],
						y: e.centerY + M[1],
						color: T
					}, e, N, P, M[0], M[1]);
					c.push({
						kind: "area",
						key: D,
						points: Z(o, r, i, a),
						path: S,
						interaction: {
							point: F,
							affinity: "geometry"
						},
						style: {
							fill: T,
							fillOpacity: n.fillOpacity,
							stroke: E,
							strokeOpacity: n.strokeOpacity,
							strokeWidth: n.strokeWidth,
							strokeDasharray: n.strokeDasharray,
							opacity: n.opacity,
							lineJoin: "round"
						}
					}), u.push(F);
				}), {
					nodes: [{
						kind: "group",
						key: f,
						className: we("ts-chart__arc", n.className),
						ariaHidden: !0,
						children: c
					}],
					points: u
				};
			}
		};
	}, n.motion, n.renderer);
}
function ue(e, n = {}) {
	let a = be(e);
	return he(({ markIndex: e, parentId: u, states: f }) => {
		let p = n.id ?? `${u}:radial-text-${e}`, m = n.angleScale ?? "angle", h = n.radiusScale ?? "radius", g = typeof n.angle == "number" ? a.map(() => n.angle) : o(a, n.angle, (e, { index: t }) => t), _ = typeof n.radius == "number" ? a.map(() => n.radius) : o(a, n.radius, (e) => typeof e == "number" ? e : void 0), v = o(a, n.text, (e) => e == null ? "" : String(e)), y = o(a, n.z, () => null), b = n.color === void 0 ? y : o(a, n.color, () => null), x = r(a, n.key, { groups: y });
		return {
			id: p,
			states: i(a, n.states ?? f),
			angleScale: m,
			radiusScale: h,
			colorValues: b.filter(t),
			angleValues: g.filter(c),
			radiusValues: _.filter(c),
			includeZeroRadius: !1,
			requiresAngleScale: !0,
			requiresRadiusScale: !0,
			render: ({ layout: e, color: t, theme: r }) => {
				let i = ge(e, m, "angle", `Polar mark "${p}"`), o = ge(e, h, "radius", `Polar mark "${p}"`), u = [], f = [];
				return a.forEach((m, h) => {
					let S = g[h], C = _[h], w = v[h], T = _e(i, S), E = _e(o, C);
					if (!c(S) || !c(C) || w == null || !s(T) || !s(E)) return;
					let D = l(n.radiusOffset, m, h, a, 0), O = E + D;
					if (!s(D) || !s(O)) return;
					let [k, A] = F(T, O), j = k + l(n.dx, m, h, a, 0), M = A + l(n.dy, m, h, a, 0), N = y[h] ?? null, P = b[h] ?? null, I = l(n.fill, m, h, a, P == null ? r.foreground : t(P)), L = `${p}:${d(N)}:${d(x[h])}`, R = l(n.anchor, m, h, a, "middle");
					u.push({
						kind: "label",
						key: L,
						x: j,
						y: M,
						text: String(w),
						anchor: R === "outside" ? Ce(T, e.direction) : R,
						baseline: l(n.baseline, m, h, a, "middle"),
						rotate: n.rotate === void 0 ? void 0 : l(n.rotate, m, h, a, 0),
						fontSize: n.fontSize,
						fontWeight: n.fontWeight,
						style: { fill: I }
					}), f.push(Y({
						key: L,
						markId: p,
						group: N,
						groupLabel: N == null ? p : String(N),
						datum: m,
						datumIndex: h,
						xValue: S,
						yValue: C,
						x: e.centerX + j,
						y: e.centerY + M,
						color: I
					}, e, T, O, j, M));
				}), {
					nodes: [{
						kind: "group",
						key: p,
						className: we("ts-chart__radial-text ts-chart__text", n.className),
						ariaHidden: !0,
						children: u
					}],
					points: f
				};
			}
		};
	}, n.motion, n.renderer);
}
function de(e, t, n, r) {
	let i = xe(e.startAngle, 0), a = xe(e.endAngle, se), o = Math.max(0, xe(e.inset, 0)), s = Math.max(0, xe(e.radiusRatio, 1)), c = Math.max(0, Math.min(t.width, t.height) / 2 - o) * s, l = fe(e), u = {}, d = {
		chart: t,
		centerX: t.x + t.width / 2,
		centerY: t.y + t.height / 2,
		radius: c,
		startAngle: i,
		endAngle: a,
		direction: r,
		scales: u
	};
	for (let [e, t] of Object.entries(l)) {
		if (!t) continue;
		let r = e === "angle" || e === "radius" ? e : void 0, o = r ?? t.channel;
		if (!o) throw TypeError(`Named polar scale "${e}" requires channel: "angle" or channel: "radius"`);
		if (t.channel && t.channel !== o) throw TypeError(`Polar scale "${e}" is reserved for ${o} but declares channel: "${t.channel}"`);
		if (r && !n.some((t) => r === "angle" ? t.angleScale === e : t.radiusScale === e)) throw TypeError(`Polar scale "${e}" cannot be configured when no mark materializes its channel`);
		let s = me(n, o === "angle" ? "angleValues" : "radiusValues", e), c = o === "radius" && n.some((t) => t.radiusScale === e && t.includeZeroRadius), l, f, p = !1;
		if (o === "angle") l = i, f = a, p = t.wrap ?? Se(i, a);
		else {
			let e = ve(t.range, d);
			l = e[0], f = e[1];
		}
		u[e] = pe(e, o, t.scale, s, l, f, p, c, t.nice);
	}
	return d;
}
function fe(e) {
	let t = e.scales;
	if (!t || !Object.hasOwn(t, "angle") || !Object.hasOwn(t, "radius")) throw TypeError("Polar scales must define reserved `angle` and `radius` entries");
	return t;
}
function pe(e, t, n, r, i, a, o, s, l) {
	let d = u(n, {
		values: r,
		includeZero: s,
		nice: l,
		niceCount: 5
	}), f = d.domain().filter(c), p = o && typeof d.bandwidth == "function" && d.bandwidth() === 0 ? f.length > 1 ? i + (a - i) * (f.length - 1) / f.length : i : a;
	d.range([i, p]);
	let m = d.bandwidth?.() ?? 0;
	return {
		id: e,
		channel: t,
		domain: f,
		map: (e) => {
			let t = d(e);
			return typeof t == "number" && Number.isFinite(t) ? t + m / 2 : NaN;
		},
		ticks: (e) => (d.ticks?.(e) ?? f).filter(c),
		bandwidth: m
	};
}
function me(e, t, n) {
	let r = [];
	for (let i of e) if ((t === "angleValues" ? i.angleScale : i.radiusScale) === n) for (let e of i[t]) r.push(e);
	return r;
}
function he(e, t, n) {
	return q(e, t, n);
}
function ge(e, t, n, r = "Polar mark") {
	let i = e.scales[t];
	if (!i) throw TypeError(`${r} requires a configured ${n} scale "${t}" in polar.scales`);
	if (i.channel !== n) throw TypeError(`${r} uses scale "${t}" as ${n}, but it is configured for ${i.channel}`);
	return i;
}
function _e(e, t) {
	return c(t) ? e.map(t) : NaN;
}
function $(e, t, n) {
	let r = typeof e == "function" ? e(t) : e ?? n;
	return a(r) ? r : n;
}
function ve(e, t) {
	if (!e) return [0, t.radius];
	if (e.length !== 2) throw TypeError("Polar radius range must contain exactly two endpoints");
	let n = e.map((e) => typeof e == "function" ? e(t) : e);
	if (!n.every(a)) throw TypeError("Polar radius range endpoints must be nonnegative finite pixel lengths");
	return [n[0], n[1]];
}
function ye(e, t) {
	if (!e || typeof e != "object") return;
	let n = e[t];
	return s(n) ? n : void 0;
}
function be(e) {
	return Array.isArray(e) ? e : Array.from(e);
}
function xe(e, t) {
	return s(e) ? e : t;
}
function Se(e, t) {
	return Math.abs(Math.abs(t - e) - se) <= 1e-12;
}
function Ce(t, n) {
	let r = Math.sin(t);
	return Math.abs(r) <= 1e-6 ? "middle" : e(r < 0 ? "right" : "left", n);
}
function we(e, t) {
	return t ? `${e} ${t}` : e;
}
//#endregion
export { ne as i, le as n, ue as r, ce as t };

//# sourceMappingURL=polar-DKgYPero.js.map